// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"cea6f7fd","202":"34c281a0","479":"fdee6537","501":"55ee3d04","510":"22ab329b","603":"be12e5f2","722":"f2f43dab","744":"d27b0a42"}[chunkId] + ".chunk.js";
};